module.exports = __webpack_public_path__ + "static/tooling-icon-974b1e70603eb0fb1316102d1977057a.png";